import React from "react";

function Footer() {
  return (
    <>
      <footer className="relative bg-gray-300 pt-12  pb-6">
        <div
          className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20"
          style={{ height: "80px" }}
        >
          <svg
            className="absolute bottom-0 overflow-hidden"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            version="1.1"
            viewBox="0 0 2560 100"
            x="0"
            y="0"
          >
            <polygon
              className="text-gray-300 fill-current"
              points="2560 0 2560 100 0 100"
            ></polygon>
          </svg>
        </div>
        <div className="container mx-auto px-4 w-full">
          <div className="lg:flex md:flex block flex-wrap">
            <div className="w-full lg:w-1/2 px-4">
              <h4 className="text-3xl font-semibold text-Firefly font-Argent">
                Let's keep in touch!
              </h4>
              {/* <h5 className="text-lg mt-0 mb-2 text-gray-700">
              Find us on any of these platforms, we respond 1-2 business days.
            </h5> */}
              <div className="lg:flex md:blog blog lg:space-x-2 lg:space-y-0 md:space-y-2 space-y-2 pt-5">
                <input
                  type="text"
                  placeholder="Enter Email ID"
                  className="py-2 px-2 lg:w-fit md:w-full w-full text-Firefly  rounded text-sm placeholder:text-sm hover:outline-none focus:outline-none"
                />
                <button className="lg:w-fit md:w-full w-full text-white font-semibold cursor-pointer bg-redish rounded shadow-sm py-2 px-5">
                  Subscribe
                </button>
              </div>
              <div className="mt-6 lg:mb-0 md:mb-10 mb-10">
                <button
                  className="bg-white text-blue-400 shadow-lg font-normal h-11 w-11 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2 p-3"
                  type="button"
                >

                  <a
                    href="https://www.linkedin.com/company/technoweit/about/"
                    aria-label="LinkedIn"
                    target="_blank"
                    rel="noopener noreferrer"
                  >

                    <i className="flex fab fa-linkedin cursor-pointer"></i>
                  </a>
                </button>
                <button
                  className="bg-white text-blue-600 shadow-lg font-normal h-11 w-11 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2 p-3"
                  type="button"
                >
                  <a
                    href="https://www.facebook.com/technoweit"
                    aria-label="Facebook"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="flex fab fa-facebook-square cursor-pointer"></i>
                  </a>
                </button>
                <button
                  className="bg-white text-pink-400 shadow-lg font-normal h-11 w-11 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2 p-3"
                  type="button"
                >
                  <a
                    href="https://www.instagram.com/technoweit/?hl=en"
                    aria-label="Instagram"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="flex fab fa-instagram cursor-pointer"></i>
                  </a>
                </button>
                <button
                  className="bg-white text-gray-900 shadow-lg font-normal h-11 w-11 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2 p-3"
                  type="button"
                >

                  <a
                    href="https://github.com/ashishBendale777"
                    aria-label="GitHub"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="flex fab fa-github cursor-pointer"></i>
                  </a>

                </button>
              </div>
            </div>
            <div className="w-full lg:w-1/2 px-4">
              <div className="flex flex-wrap items-top mb-6 lg:space-y-0 md:space-y-5 space-y-5">
                <div className="w-full lg:w-4/12 px-4 ml-auto">
                  <span className="block uppercase text-gray-600 text-sm font-semibold mb-2">
                    Address
                  </span>
                  <p className="text-gray-600 text-sm mb-2 ">
                    9, Anant Housing Society,Opposite M. J. College.Jalgaon (M.S.) 425001
                  </p>
                </div>
                <div className="w-full lg:w-4/12 px-4 ml-auto">
                  <span className="block uppercase text-gray-600 text-sm font-semibold mb-2">
                    Useful Links
                  </span>
                  <ul className="list-unstyled">
                    <li>
                      <a
                        className="text-gray-700 hover:text-gray-900 block pb-1 text-sm"
                        href={"/about"}
                      >
                        About Us
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-gray-700 hover:text-gray-900 block pb-1 text-sm"
                        href={"blog"}
                      >
                        Blog
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-gray-700 hover:text-gray-900 block pb-1 text-sm"
                        href="https://www.github.com/creativetimofficial"
                      >
                        Github
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-gray-700 hover:text-gray-900 block pb-1 text-sm"
                        href="https://www.creative-tim.com/bootstrap-themes/free"
                      >
                        Free Products
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="w-full lg:w-4/12 px-4">
                  <span className="block uppercase text-gray-600 text-sm font-semibold mb-2">
                    Other Resources
                  </span>
                  <ul className="list-unstyled">
                    <li>
                      <a
                        className="text-gray-700 hover:text-gray-900 block pb-2 text-sm"
                        href="https://creative-tim.com/terms"
                      >
                        Terms & Conditions
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-gray-700 hover:text-gray-900 block pb-2 text-sm"
                        href="https://creative-tim.com/privacy"
                      >
                        Privacy Policy
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-gray-700 hover:text-gray-900 block pb-2 text-sm"
                        href={"/contact"}
                      >
                        Contact Us
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <hr className="my-6 border-gray-400" />
          <div className="flex flex-wrap items-center md:justify-between justify-center">
            <div className="w-full md:w-4/12 px-4 mx-auto text-center">
              <div className="text-sm text-gray-600 font-semibold py-1">
                Copyright © {new Date().getFullYear()} technoweit All rights
                reserved{" "}
                <a className="text-sm text-gray-600 font-semibold">
                  Design and develop by{" "}
                </a>
                <a
                  href={"/teams"}
                  className="text-gray-600 hover:text-gray-900"
                >
                  technoweit Team
                </a>
                .
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
